<template>
    <div class="sa-pro-menu">
      <a @click="toggle" class="sa-h-sm-up">
          <span class="icon-menu-bar" :class="open?'active':'inactive'"></span>
      </a>
      <ul :class="open?'active':'inactive'">
        <li v-for="(item, i) in proMenu" @click="proMenuLink(item.info)" :class="{ 'active': activeIndex === item.info}" :key="i">
          <a>
          <i ref="ref" :class="item.icon" class="sa-h-lg-down" :title="item.info"></i>
          <span class="sa-h-sm">{{item.info}}</span>
        </a></li>
      </ul>
    </div>        
</template>
<script>
// import ClickOutside from 'vue-click-outside'
  export default {
    data() {
      return {
        ref: 1,
        activeIndex: 'Personal Information',
        open: false,
        proMenu: [
          {id:0, info: "Personal Information", icon: "icon-emplyee"},
          {id:1, info: "Medical Specialities", icon: "icon-home-plus"},
          {id:2, info: "Education & Training", icon: "icon-instructions"},
          {id:3, info: "Certifications", icon: "icon-invoice2"},
          {id:4, info: "Clinic Informations", icon: "icon-organization"},
          {id:5, info: "Language spoken", icon: "icon-global"}
        ]
      };
    },
    methods: {
      init() {
			this.proMenu = [
			    {id:0, info: "Personal Information", icon: "icon-emplyee"},
          {id:1, info: "Medical Specialities", icon: "icon-home-plus"},
          {id:2, info: "Education & Training", icon: "icon-instructions"},
          {id:3, info: "Certifications", icon: "icon-invoice2"},
          {id:4, info: "Clinic Informations", icon: "icon-organization"},
          {id:5, info: "Language spoken", icon: "icon-global"}
      ]
      let userInfo = JSON.parse(this.$localStorage.get('userdata'))
			if (userInfo && userInfo.utid !== '1') {
				this.proMenu = this.proMenu.filter(item => ((item.info != 'Certifications')));
      }
      if (userInfo && userInfo.utid == '4') {
				this.proMenu = this.proMenu.filter(item => ((item.info != 'Medical Specialities')));
      }
      if (userInfo && userInfo.eid !== 'HSP1' && userInfo.eid !== 'HSP0') {
				this.proMenu = this.proMenu.filter(item => ((item.info != 'Clinic Informations')));
      }
			this.ref = this.ref + 1
		},
      hide() {
        this.open = false
      },
      toggle() {
        this.open = !this.open
      },
      proMenuLink(i) {
        this.$emit('change', i);
        this.activeIndex = i
        this.open = false
      }
    },
    mounted: function () {
		this.init()
	},
    // directives: {
    //   ClickOutside
    // }
  };
</script>
